import { useCakeMakerActions, useCakeMakerState } from '@/store/useCakeMaker'
import { InteractiveLabel } from '../../components/InteractiveLabel'

import { Option } from '../../components/Option'
import { OptionsWrapper } from '../../components/OptionsWrapper'

import { additional } from '../../data/additional'
import { candies } from '../../data/candies'
import { toppings } from '../../data/toppings'

import { CountableOption } from '../../components/CountableOption'
import './styles.scss'

export function DetailsStep() {
  const {
    additional: selectedAdditional,
    topping: selectedTopping,
    candies: selectedCandies,
  } = useCakeMakerState()
  const { setAdditional, setTopping, addCandy, subtractCandy } =
    useCakeMakerActions()

  return (
    <div className="filling-step">
      <div className="filling-step__item">
        <InteractiveLabel id="topping-label">Cobertura</InteractiveLabel>

        <OptionsWrapper aria-labelledby="topping-label">
          {toppings.map((topping) => (
            <Option
              key={topping.id}
              value={topping.name}
              onClick={() => setTopping(topping)}
              selected={selectedTopping?.id === topping.id}
              description={topping.description}
              priceBy={{ value: topping.price, by: 'kg' }}
            />
          ))}
        </OptionsWrapper>
      </div>

      <div className="filling-step__item">
        <InteractiveLabel id="additional-label">Adicionais</InteractiveLabel>

        <OptionsWrapper aria-labelledby="additional-label">
          {additional.map((add) => (
            <Option
              key={add.id}
              value={add.name}
              onClick={() => setAdditional(add)}
              selected={selectedAdditional.some((a) => a.id === add.id)}
              description={add.description}
              priceBy={{ value: add.price, by: 'kg' }}
            />
          ))}
        </OptionsWrapper>
      </div>

      <div className="filling-step__item">
        <InteractiveLabel id="candies-label">Docinhos</InteractiveLabel>

        <OptionsWrapper aria-labelledby="candies-label">
          {candies.map((candy) => (
            <CountableOption
              key={candy.id}
              value={candy.name}
              selected={
                selectedCandies.some((c) => c.id === candy.id) &&
                candy.quantity > 0
              }
              priceBy={{ value: candy.price, by: 'un' }}
              count={selectedCandies.find((c) => c.id === candy.id)?.quantity}
              onCountSubtract={() => subtractCandy(candy)}
              onCountAdd={() => addCandy(candy)}
            />
          ))}
        </OptionsWrapper>
      </div>
    </div>
  )
}
